export default {
sets: `Sæt`,
stats: `Statistikker`,
discover: `Opdage`,
guides: `Guider`,
settings: `Indstillinger`,
unsupportedBrowserBody: `Flashcards understøtter ikke denne browser. Download den nyeste version af Chrome eller Opera, eller download vores iPhone eller Android -applikation`,
unsupportedBrowserTitle: `Ikke-understøttet browser`,
noData: `Ingen data at vise`,
contactUsTitle: `Vi elsker at høre, hvordan vores brugere bruger vores app, og hvordan vi kan forbedre os. Slip os en besked med eventuelle spørgsmål, såsom funktionsanmodninger, eller fejlrapporter`,
rateAppStore: `Bedøm i appstore`,
rateGoogle: `Bedøm i Google Play`,
close: `Tæt`,
shareFriends: `Del med venner`,
noCardsQ: `Har du ikke nogen flashcards?`,
noCardsS: `Vælg fra vores samling for at komme i gang`,
suggestSet: `Foreslå sæt`,
createOwn: `Opret din egen`,
search: `Søg`,
loading: `Indlæser`,
words: `Ord`,
downloads: `Downloads`,
export: `Eksport`,
import: `Importere`,
importing: `Import ... luk ikke appen`,
importPreview: `Import Preview`,
howQuizlet: `Sådan importeres fra Quizlet`,
cards: `Kort`,
importPreviewStatus: `__ Vilkår er klar til at blive knyttet til de eksisterende ___ -kort`,
importPaste: `Indsæt dine kort i ovenstående tekstarea`,
setTotalLimitReached: `Du kan kun have 3000 kort i et studyset`,
studying: `Studerer`,
learnt: `Lærte`,
mastered: `Mestret`,
new: `Ny`,
noTerm: `Ingen periode`,
noDef: `Ingen definition`,
cardSaved: `Kort gemt`,
reviews: `Anmeldelser`,
practices: `Praksis`,
flashcards: `Flashcards`,
alerts: `Advarsler`,
corrects: `Korrigerer`,
mistakes: `Fejl`,
reviewCycle: `Gennemgå cyklus`,
reviewsLeft: `Anmeldelser tilbage`,
lastReview: `Sidste gennemgang`,
nextReview: `Næste gennemgang`,
hideHistory: `Skjul fuld historie`,
showHistory: `Vis fuld historie`,
strength: `Styrke`,
star: `Stjerne`,
image: `Billede`,
tag: `Tag`,
added: `Tilføjet`,
removed: `fjernet`,
reviewedFrom: `Gennemgået fra __`,
notifications: `Underretninger`,
reviewedPractice: `Gennemgået __ af ___ praksis`,
successfully: `succesfuldt`,
unsuccessfully: `uden held`,
termUpdated: `Term opdateret`,
defUpdated: `Definition opdateret`,
flashcardCreated: `Flashcard oprettet`,
dropboxImage: `Du skal aktivere Dropbox Sync for at tilføje billeder`,
deleteImgConfirm: `Er du sikker på, at du vil slette dette billede?`,
uploading: `Uploading`,
save: `Gemme`,
uploadImageFail: `Kunne ikke uploade billedet`,
imageUploaded: `Billede uploadet`,
setNotFound: `Studyset ikke fundet!`,
notEnoughCards: `Ikke nok kort!`,
of: `__ af ___`,
on: `På`,
off: `Af`,
auto: `Automatisk`,
manual: `brugervejledning`,
pronounce: `Udtale`,
practiceCompleted: `Du har afsluttet denne praksis`,
closePractice: `Luk praksis`,
autoplay: `Automatisk afspilning`,
secFlipSecNext: `__ SEC FLIP, ___ SEC Næste`,
autopronounce: `Autoponounce`,
onlyTerm: `Kun sigt`,
onlyDef: `Kun definition`,
termAndDef: `Udtryk og definition`,
savePractice: `Gem praksis?`,
continueLater: `Fortsæt senere`,
deletePractice: `Slet praksis`,
term: `Semester`,
def: `Definition`,
monA: `M`,
tueA: `T`,
wedA: `W`,
thuA: `T`,
friA: `F`,
satA: `S`,
sunA: `S`,
reviewGoal: `Gennemgå mål`,
dailyGoal: `Det daglige mål`,
edit: `Redigere`,
setUp: `Opsætning`,
noRecentPractice: `Du har ikke nogen nyere praksis`,
continueLastReview: `Fortsæt sidste gennemgang`,
dueCards: `Due kort`,
studyNow: `Undersøg nu`,
newCards: `Nye kort`,
terms: `vilkår`,
defs: `Definitioner`,
validCardsOf: `Kun __ af de valgte ___ kort kan praktiseres, da de andre enten mangler udtrykket eller definitionen`,
reviewCards: `Gennemgangskort`,
customizePractice: `Tilpas praksis`,
next: `Næste`,
iWasRight: `jeg havde ret`,
printProAlert: `Køb Pro -abonnement for at udskrive mere end 20 flashcards`,
print: `Print`,
printWidth: `Term-def bredde`,
printFont: `Skriftstørrelse`,
printBorder: `Grænse`,
printMargin: `Side margin`,
printPadding: `Ordpolstring`,
preparingFile: `Forberedelse af fil`,
notificationsBlocked: `Underretninger er ikke aktiveret, du aktiverer meddelelser fra din telefons indstillinger`,
ranOutOfWords: `Løb tør for kort, genstart praksis for at starte forfra`,
ranOutOfWordsShort: `Kør tør for ord`,
ranOutOfWordsBody: `Åbn appen for at planlægge nye ord`,
proIncreaseNotifications: `Du kan øge de samlede meddelelser fra 10 til 50 i premium -versionen.`,
schedule: `Tidsplan`,
frequency: `Frekvens`,
mode: `Mode`,
tM1: `1 minut`,
tM2: `2 minutter`,
tM5: `5 minutter`,
tM10: `10 minutter`,
tM15: `15 minutter`,
tM30: `30 minutter`,
tH1: `1 time`,
tH2: `2 timer`,
termPassive: `Term passivt`,
termActive: `Term aktivt`,
defPassive: `Def passiv`,
defActive: `Def aktiv`,
scheduledIn: `Planlagt i __ minutter`,
scheduledAlertsProT: `Forøg de planlagte advarsler med Pro`,
scheduledAlertsProB: `Du kan øge de planlagte alarmer fra 10 til 50 med Pro -pakken`,
seeFeatures: `Se funktioner`,
defAndTerm: `Definition og periode`,
termHoldDef: `Udtryk, hold for at afsløre definition`,
defHoldTerm: `Definition, hold for at afsløre udtryk`,
notificationType: `Underretningstype`,
copyToClipboard: `Kopier til udklipsholder`,
enterAuthCode: `Indtast din autorisationskode`,
invalidCode: `Ugyldig kode leveret`,
copied: `Kopieret!`,
promoH2: `FlashCard Manager Pro`,
promoP: `Tryk for at finde alle premiumfunktioner for at lære mere effektivt i dit eget tempo`,
promoBtn: `Oplev alle funktioner`,
setDropboxH2: `Dropbox Sync`,
setDropboxPOff: `Aktivér Dropbox -synkronisering for at holde dine sæt, flashcards, tags og fremskridt sikkerhedskopieret og opdateret på tværs af alle dine enheder.`,
setDropboxPOn: `Dine data er sikkerhedskopieret og synkroniseret på tværs af dine enheder.`,
setDropboxBtn: `Synkronisere`,
status: `Status`,
syncNow: `Synkronisering nu`,
contact: `Kontakt`,
contactUs: `Kontakt os`,
useFromBrowser: `Brug fra browseren`,
useFromBrowserMsg: `Besøg FlashCardSmadesimple.com på din computer og gendan dine kort og licens ved at aktivere Dropbox Sync`,
termsPrivacy: `Betingelser og privatliv`,
dailyReviewGoal: `Dagligt gennemgangsmål`,
numberTerms: `Antal udtryk`,
selectTerm: `Vælg med Term Tip`,
selectDef: `Vælg med Definition Tip`,
pronounceTerm: `Udtal med Term Tip`,
pronounceDef: `Udtale med definition tip`,
typeTerm: `Skriv med Term Tip`,
typeDef: `Skriv med definition tip`,
quizTypes: `Foretrukne quiz -typer`,
spacedRepetition: `Repetitionsplan`,
spacedRepetitionP: `Registret gentagelse giver dig mulighed for at mestre ord med mindre bestræbelser ved trinvis afstand af gennemgangstiden. Standardplanen er 1-3-7-15-31 dage, men du kan også oprette en brugerdefineret.`,
spacedRepetionScheduleItem: `__ dage efter ___ anmeldelse (dag ____)`,
atLeastOneSchedule: `Der kræves mindst en tidsplan`,
revisionLimitReached: `Du nåede det maksimale omdrejningstælling`,
addReviewSchedule: `Tilføj ny gennemgangsplan`,
autoMarkLearnt: `Auto Mark lærte efter`,
autoMarkMastered: `Automark mestret efter`,
tagManager: `Tag manager`,
delete: `Slet`,
addTag: `Tilføj nyt tag`,
tagDeletionH: `Tag sletning`,
tagDeletionP: `Er du sikker på, at du vil slette dette tag?`,
cancel: `Afbestille`,
daysAfterLastReview: `Dage efter sidste gennemgang`,
linkDropbox: `Link Dropbox`,
startSync: `Start synkronisering`,
starred: `Medvirkende`,
images: `Billeder`,
tags: `Tags`,
types: `Typer`,
activeDays: `Aktive dage`,
inactiveDays: `Inaktive dage`,
longestStreak: `Længste stribe`,
dailyGoalsCompleted: `Daglige mål afsluttet`,
dailyGoalsFailed: `Daglige mål mislykkedes`,
typePairs: `Type par`,
reviewTypes: `Gennemgangstyper`,
typePractice: `Skriv praksis`,
pronouncePractice: `Udtale praksis`,
selectPractice: `Vælg praksis`,
notificationReview: `Underretningsanmeldelse`,
flashcardReview: `Flashcard Review`,
studyset: `Studyset`,
enterStudysetName: `Indtast et navn på dit Studyset`,
studysetName: `Indtast sættets navn`,
termType: `Term Type / Lang`,
defType: `Definition Type / Lang`,
exportCards: `Eksportkort`,
importCards: `Importkort`,
quiz: `Quiz`,
showingOutOfCards: `Viser __ ud af ___ kort`,
showingAllCards: `Viser alle kort, skriv ind i ovenstående søgefelt eller tryk på eventuelle tags for at filtrere`,
recording: `Indspilning`,
downloadSet: `Føj til mine sæt`,
addNewCard: `Tilføj nyt kort`,
saveStudyset: `Gem undersøgelsessæt`,
studysetDeletionH: `Studyset -sletning`,
studysetDeletionP: `Er du sikker på, at du vil slette dette Studyset, dette vil også slette alle indeholdte kort.`,
cardDeletionH: `Kort sletning`,
cardDeletionP: `Er du sikker på, at du vil slette dette kort`,
cardLimitReached: `Du kan kun have 3000 kort i et studyset`,
limitExceeded: `Grænsen overskredet`,
atLeastTenCards: `Tilføj mindst 10 kort for at komme i gang med praksis`,
searchInAll: `Søg i alle undersøgelsessæt`,
noMatch: `Intet match`,
atLeastThreeChars: `Indtast mindst 3 tegn for at søge`,
noSets: `Ingen sæt`,
startingSync: `Start synkronisering`,
noSetsP: `Vælg fra nedenstående indstillinger for at komme i gang`,
startingSyncP: `Vi får dine data fra Dropbox, dette kan tage et stykke tid`,
createNewStudyset: `Opret nyt Studyset`,
restoreFromBackup: `Gendan fra backup -fil`,
setStarterPacks: `Studyset Starterpacks`,
selectPracticeType: `Vælg øvelsestype`,
noDueCards: `Der er endnu ingen på grund af flashcards, flashcards, som du har gennemgået før, begynder at dukke op her efter den valgte afstands gentagelsesplan for at hjælpe dig med at mestre ord med mindre indsats og tid`,
noNewCards: `Ingen nye kort at studere`,
subscriptionH: `Køb Pro for at nyde alle funktionerne og for at støtte den fortsatte udvikling.`,
buyLifetimePro: `Køb Lifetime Pro til __`,
restorePurchase: `GENDAN KØB`,
termsPrivacyC: `Betingelser og privatlivspolitik`,
licenceShare: `Hvis du har købt en licens fra en anden enhed, kan du dele den med denne enhed ved at aktivere Dropbox -synkronisering på begge enheder`,
enterTagName: `Indtast navnet på mærket`,
invalidName: `Ugyldigt navn`,
create: `skab`,
name: `Navn`,
tagName: `Navn på dit tag`,
color: `Farve`,
back: `Tilbage`,
rowSeparator: `Række separator`,
termDefSeparator: `Term - Def Separator`,
output: `Produktion`,
inputCards: `Indgangskort`,
review: `Anmeldelse`,
language: `Sprog`,
archiveReversible: `Arkiv (reversibelt fra indstillinger)`,
deletePermanent: `Slet (irreversibel)`,
archivedCards: `Arkiverede kort`,
masteredCards: `Masterede kort`,
due: `På grund`,
reviewed: `Gennemgået`,
markReviewed: `Mark Reviewed`,
markMastered: `Mark Masteret`,
forXYCards: `For __ ___ kort`,
createdAtSortBy: `Oprettelsesdato`,
lastReviewedSortBy: `Sidste gennemgangsdato`,
reviewCountSortBy: `Antal anmeldelser`,
strengthSortBy: `Styrke`,
termSortBy: `Alfabetisk betegnelse`,
definitionSortBy: `Alfabetisk def.`,
ascSortBy: `Stigende`,
descSortBy: `Aftagende`,
featureSync: `Undersøg noget og hvor som helst og når som helst med dine flashcards synkroniseret på tværs af alle dine enheder`,
featureSpacedrepetition: `Se på dine samlede fremskridt, og kom tilbage til at øve det, du har brug for at øve`,
featureNotifications: `Supercharge din læring uden selv at åbne appen med fleksible meddelelser`,
featureFlashcards: `Autoplay flashcards, når dine hænder eller øjne har travlt, men du har stadig uudnyttet opmærksomhed`,
featureQuiz: `Match, stave ud, lyt eller vælg at øve dine flashcards`,
featureStats: `Få bedre indsigt i dine kort og resultater, og søg på tværs af alle dine flashcard -sæt`,
featureImport: `Vi vil aldrig gemme nogen data om dig, og du kan let eksportere og importere alle dine data`,
featurePrint: `Få noget læring udført ved at udskrive dine flashcards, og DIY din egen studerer rig`,
splashIntro: `Undersøg alle dine flashcards overalt i dit tempo og stil`,
selectSortOrder: `Sorteringsrækkefølge`,
selectSortProp: `Sorter egenskab`,
applyFilters: `Anvend filtre`,
selectSetType: `Hvad vil du øve?`,
getStarted: `Kom igang`,
tapToUnarchive: `Tryk på de kort, du vil være uarkiv`,
untitled: `UNTITLED`,
sortHintNew: `Du vil se kortene, der blev oprettet for den længste tid siden først`,
sortHintDue: `Du vil se kort, der er forfalden for den længste først`,
sortHintOther: `Du vil se kort, der ikke er blevet undersøgt den længste først`,
flashcardsWhen: `, når dine hænder eller øjne har travlt, selv mens du lytter til musik / podcasts`,
notificationsWhen: `, for når du er ude og bare vil have hurtige studiebits`,
quizWhen: `, for når du kan være fuld opmærksomhed for at studere, for at mestre dine kort`,
features: `Funktioner`,
ratings: `Bedømmelser`,
notificationDailyCatchUpBody: `Ny: __, på grund: ___, studerer: ____, lært: _____, mestret: ______`,
notificationDailyCatchUpTitle: `Daglig opsamling`,
reviewedJN: `Gennemgået lige nu`,
customUpdated: `Brugerdefineret tekst opdateret`,
customTextField: `Synonymer, eksempler osv.`,
field: `Mark`,
link: `Link`,
backToParentCard: `Tilbage til forældrekort`,
discard: `Kasser`,
failedImageLoad: `Kunne ikke indlæse billedet, sørg for, at du er tilsluttet internettet`,
printDIYLabel: `DIY dit eget kreative papirbaserede studieopsætning, del med os din oprettelse og bliv med i appen.`,
reviewGraphChart: `Gennemgangsfrekvens`,
langNotSet: `Sprog ikke indstillet`,
pronouncationLangInfo: `For at muliggøre udtale skal du vælge udtrykket og definitionens sprog. Et højttalerskilt vises ved siden af ​​sprogene, hvis din enhed understøtter dette sprog`,
clearFilters: `Ryd filter`,
subFreeUnlimited: `Ubegrænsede studysetter, flashcards, praksis, søgning og synkronisering`,
customFields: `Brugerdefinerede felter`,
subLinks: `Kortlink`,
subPrint: `Print / Studyset`,
subNotifications: `Meddelelse inden du skal åbne appen`,
subCardsStudysets: `Kort / Studyset`,
subRevisionCycles: `Brugerdefinerede revisionscyklusser`,
subscriptionHEnd: `Opgradering til Pro viser os, at du finder vores hårde arbejde værdifuldt og giver os opmuntring og kaffe til at fortsætte med at forbedre og skabe nye fantastiske ting.`,
subFree: `Ledig`,
subPro: `Pro`,
guideSpacedRepetition: `Hvordan fungerer afstands gentagelsesarbejde og praksistyper`,
guideSearch: `Søgning og filtrering`,
guideSync: `Aktivér backup og synkronisering på tværs af dine enheder`,
guidePronunciation: `Aktivér udtalelser`,
guideImport: `Importerer kort fra at forlade kilder`,
guideAccess: `Hvem har adgang til mine data?`,
guideData: `Hvilke data indsamler vi?`,
guideContact: `Brug for hjælp til noget andet? Skriv til os`,
arrowStrength: `Indstil hvor godt du kender dette kort`,
arrowImage: `Tilføj billeder`,
arrowField: `Tilføj yderligere tilpassede tekstfelter`,
arrowTag: `Vedhæft tags`,
arrowStar: `Mark som favorit`,
arrowLink: `Link til andre kort`,
arrowGoal: `Opret et dagligt gennemgangsmål for dig selv`,
arrowDue: `Undersøgelsesord, der skal gennemgås`,
arrowNew: `Studiekort, der ikke er gennemgået endnu`,
arrowMastered: `Hvis du ikke har nogen forfaldne eller nye kort, kan du gennemgå Masteret kort for at holde dem mestret`,
arrowImport: `Importer dine eksisterende flashcards`,
arrowNewCard: `Tilføj en ny flashcards`,
dropboxStep1: `1. Få adgangskode fra Dropbox ved at logge ind`,
dropboxStep1Btn: `Log ind med Dropbox`,
dropboxStep2: `2. Indtast adgangskoden nedenfor`,
dropboxStep2Input: `Indtast kode her`,
dropboxStep3: `3. Start synkronisering`,
alreadyLinked: `Allerede knyttet, tryk på for at løsne`,
selectCardsToLink: `Vælg kort for at linke`,
unsupportedLangP: `Vælg et sprog, der understøtter udtale fra sættets indstillinger`,
links: `Links`,
emailUs: `Send os en e -mail`,
whatsappUs: `Whatsapp os`,
printMinHeight: `Min. Rækkehøjde`,
exportType: `Eksportfiltype`,
generateFileText: `Generere fil`,
generatatingFile: `Generering af fil`,
verySmall: `Meget lille`,
small: `Lille`,
normal: `Normal`,
big: `Stor`,
veryBig: `Meget stor`,
repeatNTimes: `Gentag __ gange`,
pause: `Pause`,
for: `til`,
say: `Sige`,
defShort: `Defin.`,
times: `gange`,
autoplayPreferences: `Indstil AutoPlay -præferencer`,
autoPlay1: `Pause efter forrige ord`,
autoPlay2: `Antal udtalelser`,
autoPlay3: `Pause, før jeg afslører definition`,
autoPlay4: `Antal udtalelser`,
autoPlay5: `Pause inden du viser næste ord`,
autoPlay6: `Gentag det samme flashcard`,
startAutoPlay: `Start autoplay`,
autoPlayOffConfirm: `Sluk for autoplay for at aktivere manuelle kontroller`,
turnOff: `Sluk`,
keepPn: `Fortsæt`,
foundIn: `Fundet i __`,
repeat: `gentage`,
stop: `Hold op`,
listenInBreak: `Vidste du? Du kan lytte til musik / podcasts i pauser`,
contextSearch: `Kontekstsøgning`,
contextSearchText: `Få eksempler på, hvordan __ bruges i forskellige sætninger`,
transalteSearch: `Oversætte`,
translateSearchText: `Oversæt __ til ___`,
synonymSearch: `Synonym søgning`,
synonymSearchText: `Søg efter synonymer på __`,
selectToAdd: `Vælg de resultater, du vil tilføje til dette kort`,
addToCard: `Tilføj valgt til kortet`,
hideFromPractice: `Skjul i runde`,
setLanguageRequired: `Vælg sproget for udtryk og definitioner i Studyset Detaljerne`,
fieldNeedsText: `Indtast noget i dette felt, før du søger`,
possibleDupe: `Mulig duplikat`,
loadNextXCards: `Indlæs næste __ kort`,
repeatPractice: `Gentag disse __ -kort`,
keepScreenOnInfo: `Du skal muligvis justere din auto-lock-indstilling for at holde skærmen på, mens du er autoplaying.`,
siteLoginH2: `SFM -konto`,
siteLoginP: `Du kan bruge dine flashcards lavet enkel konto til at dele dine flashcards med dine venner, dine studerende eller hele samfundet.`,
logOut: `Log ud`,
logIn: `Log på`,
createAccount: `Opret ny konto`,
signUp: `Tilmelde`,
username: `Brugernavn`,
email: `E -mail`,
password: `Adgangskode`,
networkError: `Netværksfejl`,
fillAllDetails: `Udfyld venligst alle detaljer`,
noUserWithDetails: `Ingen bruger fundet med de indtastede detaljer`,
userAlreadyExists: `Den givne e -mail eller brugernavn findes allerede`,
signUpOrLoginToCont: `Tilmeld dig eller log ind for at fortsætte?`,
atLeastOneCardToShare: `Der kræves mindst et kort for at dele`,
publishingStudyset: `Publishing Studyset`,
updatesDetected: `Opdateringer, der er registreret, vil du fortsætte med at opdatere lokale data? (Slettet: __, opdateret: ___, nyt: ____)`,
updatesApplied: `Opdateringer anvendt`,
alreadyUpToDate: `Allerede ajour`,
practiceTypeArrow: `Oplev forskellige måder at stille til`,
share: `Del`,
sharingModalIntro: `Del dine flashcards i dette sæt med dine venner, dine studerende eller hele samfundet.`,
whatIsShared: `Hvad der deles`,
whatIsNotShared: `Hvad deles ikke`,
whatIsSharedText: `Indstil navn, sæt termsprog, definitivt sprog, alle inkluderede kort med udtryk, definitioner, brugerdefinerede tekstfelter og billeder`,
whatIsNotSharedText: `Eventuelle kortstyrker, stjerner, links, tags og din gennemgangshistorie`,
checkForSharedUpdates: `Kontroller for opdateringer fra skaberen`,
fetchUpdates: `Hent opdateringer`,
youSharedStudyset: `Du delte dette Studyset`,
publishChanges: `Gem og offentliggør ændringer`,
redeem: `Indløs`,
noAds: `Ingen annoncer`,
dupeDetection: `Duplikatdetektion`,
coffeeFeature: `Kaffe, for at hjælpe os med at udvikle flere funktioner`,
shareLink: `Del link`,
coffeeForUs: `Du får kun en livstidslicens til __, hvilket giver Emily 6 kaffe, Dominik 3 -kaffe og Russ 3 -kaffe, som vil brænde os i cirka 39 timer for at gøre denne app -begivenhed bedre`,
sharingCards: `Deling af kort`,
published: `Offentliggjort`,
alreadyHaveAccount: `har du allerede en bruger?`,
notAlreadyHaveAccount: `Har du ikke en konto endnu?`,
startPractice: `Start praksis`,
selectQuizTypes: `Vælg quiz -typer`,
correct: `Korrekt`,
incorrect: `Ukorrekt`,
yes: `Ja`,
no: `Ingen`,
levelSilver: `Sølvniveau __`,
levelGold: `Guldniveau __`,
levelPlatinum: `Platinumniveau __`,
levelDiamond: `Diamantniveau __`,
levelJade: `Jade niveau __`,
reviewsLeftGoal: `__ Anmeldelser til det daglige mål`,
dailyGoalAchieved: `Det daglige mål`,
share: `Del`,
rateApp: `Bedøm app`,
allStats: `Alle statistikker`,
reviewTimeError: `Timeout efter fejl`,
reviewTimeCorrect: `Timeout efter korrekt`,
pronounceTermAfterReview: `Udtale sig efter gennemgang`,
pronounceDefinitionAfterReview: `Udtale definition efter gennemgang`,
practice: `Øve sig`,
notificationsScheduledInfo: `__ Meddelelser er planlagt, du kan lukke appen nu`,
wellDone: `Godt klaret`,
keepItUp: `Bliv ved`,
youRock: `Du styrer`,
niceOne: `Den var god`,
lnSelect: `Vælg sprog`,
sampleData: `Ingen anmeldelser, der viser eksempeldata`,
reviewFreq: `Gennemgangsfrekvens`,
selectPractice: `Øvelse: Vælg`,
spellPractice: `Øvelse: Stave`,
connectPractice: `Øvelse: Opret forbindelse`,
languages: `Sprog`,
languagesPairs: `Sprog par`,
shareArrow: `Del sæt med venner, studerende eller hele samfundet`,
cardsPerRound: `Kort / runde`,
showAll: `Vis alt`,
supportedLangsVary: `Understøttede sprog varierer`,
practiceWithoutSave: `Øv dig ikke gemt`,
practiceWithoutSaveBody: `Du har ikke tilføjet dette Studyset til din samling, vil du tilføje det nu for at gemme din undersøgelse?`,
saveSetNow: `Gem kort til din samling`,
continueWithoutSaveSave: `Start praksis uden at redde`,
createdBy: `Lavet af`,
setSavedToYourCollection: `Undersøgelsessæt gemt i din samling`,
accountBackupDisclaimer: `Bemærk, at denne konto kun kan bruges til deling af studysetter med andre, og at de ikke kan bruges til at tage backup af eller synkronisere dine studysetter eller flashcards. For at synkronisere og sikkerhedskopiere alle dine data, skal du bruge Dropbox Sync`,
syncEnabled: `Synkronisering aktiveret, hentning af dit igangværende indhold`,
searchAllSets: `Søgningsundersøgelsessæt fra andre brugere`,
anyLanguage: `Ethvert sprog`,
trendingIn: `Trending i`,
manualBackups: `Manuel sikkerhedskopi`,
manualBackupCreate: `Opret manuel sikkerhedskopi`,
confirmManualImport: `Er du sikker på, at du vil erstatte alle aktuelle data med denne sikkerhedskopi? Dette anbefales kun på nye enheder uden data`,
importFromManualBackup: `Import fra backup`,
imgOfflineSets: `Auto-download-billeder til offline læring`,
unsupportedDeviceCache: `Denne funktion er kun tilgængelig fra iOS- eller Android -appen`,
shareChanges: `Del __ ændringer`,
publiclySearchable: `Søgbar af brugere`,
description: `Beskrivelse`,
restoreFromDropboxBackup: `Gendan fra Dropbox -sikkerhedskopi`,
imageCacheStudysetSub: `[IOS & Android kun] Download billede til offline studier`,
keywordsOrLangNeeded: `Du skal indtaste nogle nøgleord eller et sprog`,
dropboxAlreadyLinked: `Dropbox -konto er allerede knyttet`,
noSetUpdateAccess: `Du har ikke adgang til at redigere dette undersøgelsessæt.`,
confirmSetOwnerLogin: `Hvis du er sikker på, at du er ejeren, så prøv at logge ind på din konto igen.`,
uninitedRestriction: `For at gemme dine fremskridt skal du først tilføje dette studyset til din samling`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `Kunne ikke konsolidere opbevaring`,
consolidateStorageDone: `Lagringskonsolidering, lad venligst op til en time for Dropbox at afslutte at fjerne gamle filer, før du logger ind på en ny enhed.`,
consolidatingStorage: `Konsolidering af opbevaring ...`,
deleteAccount: `Slet konto`,
consolidateStorageDescription: `Denne operation vil genindeks dine sikkerhedskopieringsfiler, så det vil være hurtigere at konfigurere en ny enhed`,
consolidatingStorageConfirm: `Sørg for, at alle dine ændringer allerede er færdige med at synkronisere, ikke synkronisere andre enheder, mens denne proces finder sted. Vil du fortsætte?`,
consolidateStorage: `Konsoliderer opbevaring`,


}